import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../context/authContext";
import {
  deleteAccount,
  getEntitlements,
  getPreferences,
  getSubscription,
  Preferences,
  putPreferences,
} from "../http/onlyclicksApi";

export const useDeleteAccount = () => {
  const auth = useAuth();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteAccount(id),
    onSuccess: () => {
      // TODO: Verify is this works
      queryClient.invalidateQueries();
      return auth.signOut();
    },
  });
};

export const useEntitlements = () => {
  const auth = useAuth();
  const userId = auth.session?.id;
  return useQuery({
    queryKey: ["entitlements"],
    queryFn: (ctx) => getEntitlements(ctx.signal, userId!),
    enabled: auth.hasActiveSession,
    retry: false,
  });
};

export const useSubscription = () => {
  const auth = useAuth();
  const userId = auth.session?.id;
  return useQuery({
    queryKey: ["subscription"],
    queryFn: (ctx) => getSubscription(ctx.signal, userId!),
    enabled: auth.hasActiveSession,
    retry: false,
  });
};

export const usePreferences = () => {
  const auth = useAuth();
  const userId = auth.session?.id;
  return useQuery({
    queryKey: ["preferences"],
    queryFn: (ctx) => getPreferences(ctx.signal, userId!),
    enabled: auth.hasActiveSession,
    staleTime: Infinity,
  });
};

export const usePreferencesMutation = () => {
  const auth = useAuth();
  const userId = auth.session?.id;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (newPreferences: Preferences) =>
      putPreferences(userId!, newPreferences),
    onSuccess: (preferences) => {
      queryClient.setQueryData(["preferences"], preferences);
    },
  });
};
